import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { callEditorApi } from 'owa-editor/lib/utils/callApi';
import { OWA_INSERT_LINK_PLACEHOLDER_CLASSNAME } from './constants';
import { QueryScope } from 'roosterjs-editor-types';

export function getAllInsertLinksIds(editorViewState: EditorViewState): string[] {
    const selector = '.' + OWA_INSERT_LINK_PLACEHOLDER_CLASSNAME;
    let allInsertLinks = callEditorApi(editorViewState, 'queryElements', selector, QueryScope.Body);

    if (!allInsertLinks) {
        const doc = new DOMParser().parseFromString(editorViewState.content, 'text/html');
        allInsertLinks = [].slice.call(doc?.querySelectorAll(selector) || []) as HTMLElement[];
    }

    return (allInsertLinks || []).map(element => element.id);
}
